export const FAKE_COMMENT_DATA_ID = '374d515b-0527-428c-a2f6-7830d4f2218a';
